var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"float-right my-4",style:(_vm.theme),attrs:{"small":_vm.small,"block":_vm.block,"href":_vm.urlEncodedMsg,"target":"_blank"}},[_vm._v(_vm._s(_vm.block?'Share':'')),_c('v-icon',[_vm._v("mdi-share-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }